import type { SidebarItem } from '../components/Sidebar';

/**
 * The shared sidebar configuration for every business page on
 * `/app/*`. Pages pull `dashboardSidebar` directly so that adding
 * or removing a sidebar entry is a one-file change.
 *
 * The `brand` string is duplicated from the historical hard-coded
 * `ExamplesDashboard` render. The `user` object is kept here for
 * the same reason.
 */

export type DashboardSidebarConfig = {
  brand: string;
  items: SidebarItem[];
};

export const dashboardSidebar: DashboardSidebarConfig = {
  brand: 'EXCEL HR',
  items: [
    { id: 'workbench', label: '工作台',   icon: 'home' },
    { id: 'people',    label: '员工管理', icon: 'users' },
    { id: 'attendance',label: '考勤管理', icon: 'clock' },
    { id: 'payroll',   label: '薪酬管理', icon: 'wallet' },
    { id: 'recruit',   label: '招聘管理', icon: 'briefcase' },
    { id: 'approval',  label: '审批管理', icon: 'check' },
    { id: 'analytics', label: '数据分析', icon: 'bar' },
    { id: 'settings',  label: '系统设置', icon: 'settings' }
  ]
};

export const dashboardUser = {
  name: '随心系',
  role: '管理员'
};

/**
 * Lightweight page props shared by every `/app/*` page. Each page
 * forwards its `settingsPanel` + `mobileMenu` + `sidebarOpen` from
 * `App.tsx` through to `<DashboardLayout>`.
 */
export type BusinessPageProps = {
  settingsPanel?: React.ReactNode;
  mobileMenu?: React.ReactNode;
  sidebarOpen?: boolean;
};
